<template>
  <div>
    <div class="GatewayResource-title">
      <div>{{ $t("RAM.AWS.Gateway.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:gatewayResource:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          :loading="modal_loading"
          @click="exportList"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:gatewayResource:export'
          ]"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="GatewayResource-top">
      <gateway-resource-search
        ref="gatewayResourceSearchChild"
      ></gateway-resource-search>
    </div>
    <table-gateway-resource></table-gateway-resource>
  </div>
</template>

<script>
import GatewayResourceSearch from "../gateway/GatewayResourceSearch";
import TableGatewayResource from "../gateway/TableGatewayResource";
import TableVirtualPrivateCloudResource from "../vpc/TableVirtualPrivateCloudResource";

export default {
  name: "GatewayResource",
  components: {
    GatewayResourceSearch,
    TableGatewayResource
  },
  data() {
    return {
      loading: false,
      modal_loading: false,
      accountNameSearchID: "",
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.companyId = this.$refs.gatewayResourceSearchChild.companyId;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 10
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      // 获取子组件数据
      this.accountNameSearchID = this.$refs.gatewayResourceSearchChild.accountNameSearchKey;
      this.companyId = this.$refs.gatewayResourceSearchChild.companyId;
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAWSGateway({
          accountName: this.accountNameSearchID,
          companyId: this.companyId
        })
        .then(res => {
          let fileName = this.$t('RAM.export.gateway');
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t('common.exportSuccess'));
        });
    }
  }
};
</script>

<style scoped>
.GatewayResource-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.GatewayResource-title > div:nth-child(1) {
  float: left;
}
.GatewayResource-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.GatewayResource-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/gateway/GatewayResource.vue